import { render, staticRenderFns } from "./tenantpackage.vue?vue&type=template&id=2ec4dbc2"
import script from "./tenantpackage.vue?vue&type=script&lang=js"
export * from "./tenantpackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports